module.exports = __webpack_public_path__ + "img/paragraph.5d0178c0.svg";